import React from 'react';
import styled from 'styled-components/macro';

import {Page} from '../../../../shared';
import {NODEJS_API_URL} from '../../../../config.json';
import store from '../../../../shared/store';

const _Iframe = styled.iframe`
  width: 100%;
  height: 1000px;
  margin: 70px 15px 15px 15px;
`;

const BillFin = () => {
  const runAs = localStorage.getItem('runAs');
  const session = store.getState().session;

  let url = NODEJS_API_URL + '/auth/billFin/login?email=' + (session.email || localStorage.email)
    + '&token=' + (session.token || localStorage.token);

  if (runAs && session.profile && session.profile.id) {
    url += '&runAs=' + session.profile.id;
  }

  return (
    <Page>
      <_Iframe seamless='seamless' src={url}/>
    </Page>
  );
};

export default BillFin;
